import React from "react"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import AlertModal from "../fragments/AlertModal"
import ProcessesStatus from "../fragments/ProcessesStatus"

export default class UpdateBundleStatus extends React.Component {

  state = {
    running: false,
    success: false,
    error: null,
  }

  closeStatusForm = () => {

    this.setState({
      running: false,
      success: false,
      error: null,
    })
    this.props.close()
  }

  confirmChangeStatus = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { bundleId, active, setBundle } = this.props

    blockingFetchService(
      accessToken => apiServerApi.changeBundleStatus(accessToken, bundleId, !active),
      resp => {
        this.setState({ success: true })
        setTimeout(() => {
          this.closeStatusForm()
          setBundle(bundleId, resp)
        }, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderContent = () => {

    const { active } = this.props,
    { running, success, error } = this.state
    return (
      <div>
        <h3>{ active ? 'Disable' : 'Enable' } this bundle?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  render() {

    const { show } = this.props,
    { running } = this.state

    return (
      <AlertModal
        show={ show }
        title="Confirm update"
        body={ this.renderContent() }
        bsStyle="danger"
        close={ this.closeStatusForm }
        confirm={ this.confirmChangeStatus }
        proceedText="Proceed"
        disabled={ running }
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Bundles/UpdateBundleStatus.js